import React, { useMemo } from "react"
import { useAppContext } from "../../app/Context"
import { Agent } from "../../types/Agent"
import { Loader } from "../loader"

interface AgentVideoProps {
  agent: Agent
  isEmbed?: boolean
}

export function AgentVideo({ agent, isEmbed = false }: AgentVideoProps) {
  // const [loadingVideo, setLoadingVideo] = useState<boolean>(false)

  const context = useAppContext()
  const { user, isAgentVideoLoading } = context

  const videoUrl = useMemo(() => {
    if (user) return agent?.avatar_video_url
    return
  }, [user, agent])

  const showLoading = isAgentVideoLoading
  if (showLoading) return <Loader />
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: isEmbed ? "100vh" : "100%",
      }}
    >
      {showLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(0, 0, 0, 0.15)",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            border: "1px solid rgba(255, 255, 255, 0.18)",
            borderRadius: "1rem",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop:
                "4px solid var(--primitives-desktop-primary-brand-violet-800)",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
        </div>
      )}
      <video
        src={videoUrl}
        autoPlay
        muted
        loop
        playsInline
        // onLoadedData={() => setLoadingVideo(false)}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "40%",
          background:
            "linear-gradient(180deg, rgba(21, 0, 73, 0) 0%, rgba(21, 0, 73, 0.2) 60%, rgba(21, 0, 73, 0.6) 100%)",
          maskImage:
            "linear-gradient(180deg, transparent 0%, black 30%, black 100%)",
          WebkitMaskImage:
            "linear-gradient(180deg, transparent 0%, black 30%, black 100%)",
          backdropFilter: "blur(6px)",
          pointerEvents: "none",
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  )
}
